// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".nameCont[data-v-6c32a7f8] {\n  display: flex;\n  align-items: center;\n  margin-bottom: 10px;\n  font-size: 14px;\n}\n.nameCont > div[data-v-6c32a7f8] {\n  margin-left: 20px;\n}\n.nameCont span[data-v-6c32a7f8] {\n  font-weight: bold;\n  padding-right: 5px;\n  color: #40a9ff;\n}\n.btnBox[data-v-6c32a7f8] {\n  width: 100%;\n  display: flex;\n  margin-top: 20px;\n  justify-content: center;\n}", ""]);
// Exports
module.exports = exports;
